import React from 'react';
import AppHome from '../AppHome';
import { Redirect } from 'react-router-dom';
import { getUserDetails } from '../../../../common/utils/Persist';
import ROUTES from '../RouteConstants'

const PublicRoute = props => {
  const { path } = props;
  const isLoggedIn = getUserDetails('uifReadable', false)
  const isNotAutenticated = isLoggedIn == false;

  if(!isNotAutenticated){
    return <Redirect to={{ pathname: ROUTES.DASHBOARD }} />;
  }

  window.location.href = 'https://grow.g6hospitality.com?continue=https://delightiq.g6hospitality.com';
  return null;
  // return <AppHome {...props} path={path} />;

  
};

export default PublicRoute;
